import { ref } from 'vue'

export function useHoverTracker() {
    const hoverStates = ref(new Set())

    const hoverContentActive = (id, isHovering) => {
        if (isHovering) {
            hoverStates.value.add(id)
        } else {
            hoverStates.value.delete(id)
        }
    }

    const isHoverContentActive = (id) => {
        return hoverStates.value.has(id)
    }

    return {
        hoverContentActive,
        isHoverContentActive
    }
}
